<template>
  <van-button
    v-if="general"
    :class="{'can-hover': isPC, 'button-general': true}"
    v-bind="$attrs"
    v-on="$listeners">
    <slot></slot>
  </van-button>
  <van-button
    v-else
    :class="{'can-hover': isPC}"
    v-bind="$attrs"
    v-on="$listeners">
    <slot></slot>
  </van-button>
  
</template>

<script>
import { isPC } from '@/utils'
export default {
  name: 'mx-button',
  props: {
    general: Boolean
  },
  data() {
    return {
      isPC: isPC()
    }
  }
}
</script>

<style lang='less'>
  .van-button {
    border-radius: 6px;
    font-size: 16px;
    height: 40px;
    &--info {
      background-color: #2496FF;
      border-color: #2496FF;
    }
    &:active {
      background-color: #077AE5;
      border-color: #077AE5;
    }
  }
  .button-general {
    background-color: #fff;
    border-color: #2496FF;
    color: #2496FF;
  }
  .can-hover:hover {
    background-color: #83C3FF;
    border-color: #83C3FF;
  }
</style>
